import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      paddingBottom: 100,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: 560,
      padding: "80px 24px 0 24px",
    },
    header: {
      ...theme.fonts.label2,
      color: theme.colors.textDefault,
      marginBottom: 24,
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      gap: 8,
      marginTop: 24,
    },
    btn: {
      borderRadius: 0,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
